import type { PropsWithChildren } from "react";

import styles from "./Table.module.css";

export const Table = ({ children }: PropsWithChildren) => {
  return <table className={styles.adminTable}>{children}</table>;
};
